import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/FishingNavigation.css';

interface Props {
  onQuickCatch: () => void;
}

export const FishingNavigation: React.FC<Props> = ({ onQuickCatch }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="footer-nav">
      <div className="footer-nav-container">
        {/* Vänster sida */}
        <button
          onClick={() => navigate('/')}
          className={`nav-item ${isActive('/') ? 'active' : ''}`}
        >
          <div className="nav-icon">🌤️</div>
          <div className="nav-label">{t.navigationWeather}</div>
        </button>
        
        <button
          onClick={() => navigate('/catches')}
          className={`nav-item ${isActive('/catches') ? 'active' : ''}`}
        >
          <div className="nav-icon">🎣</div>
          <div className="nav-label">{t.catches}</div>
        </button>

        {/* FAB i mitten */}
        <button onClick={onQuickCatch} className="fab">
          <div className="fab-icon">+</div>
        </button>

        {/* Höger sida */}
        <button
          onClick={() => navigate('/sessions')}
          className={`nav-item ${isActive('/sessions') ? 'active' : ''}`}
        >
          <div className="nav-icon">📋</div>
          <div className="nav-label">{t.sessions}</div>
        </button>
        
        <button
          onClick={() => navigate('/areas')}
          className={`nav-item ${isActive('/areas') ? 'active' : ''}`}
        >
          <div className="nav-icon">📍</div>
          <div className="nav-label">{t.areas}</div>
        </button>
      </div>
    </div>
  );
};
